<template>
  <VButton
    type="submit"
    size="small"
    color="primary"
    class="mt-3 fw-normal"
  >
    {{ $t('Ukázať všetky výsledky') }}
  </VButton>
</template>
